import { tokens } from "@blurb/codex-react";
import { Box } from "@mantine/core";
import React from "react";
import { RpiText } from "@rpi/openapi-core";
import { RpiTableColumn } from "../RpiTable";
import { RpiTableHead } from "../RpiTableHead";
import { useRpiTableStyles } from "../RpiTableStyles";

export interface RpiTableEmptyStateProps {
  message?: string;
  columns: RpiTableColumn<any>[];
}
export const RpiTableEmptyState: React.FC<RpiTableEmptyStateProps> = ({ message, columns }) => {
  const { classes, cx } = useRpiTableStyles({ variant: "normalV2" });

  return (
    <table className={cx(classes.table, classes.variant)}>
      <RpiTableHead columns={columns} />
      <tbody>
        <tr>
          <td colSpan={columns.length}>
            <EmptyMessage message={message} />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

interface EmptyMessageProps {
  message?: string;
}

const EmptyMessage: React.FC<EmptyMessageProps> = ({ message = "No data found." }) => {
  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: tokens.color.semantic.bg.surface,
        padding: tokens.spacing[6],
        gap: tokens.spacing[4],
      }}
    >
      <Box sx={{ display: "block" }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100" fill="none">
          <g clipPath="url(#clip0_9791_30567)">
            <rect width="100" height="100" fill="#DEDEDE" />
            <line
              y1="-0.5"
              x2="141.418"
              y2="-0.5"
              transform="matrix(0.707124 0.70709 -0.39122 0.920297 0 0.00390625)"
              stroke="#9A9FA1"
            />
            <line
              y1="-0.5"
              x2="141.418"
              y2="-0.5"
              transform="matrix(0.707088 -0.707125 0.391186 0.920311 0 100)"
              stroke="#9A9FA1"
            />
          </g>
          <rect x="0.5" y="0.5" width="99" height="99" stroke="#9A9FA1" />
          <defs>
            <clipPath id="clip0_9791_30567">
              <rect width="100" height="100" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </Box>
      <RpiText type="p2" weight="normal">
        {message}
      </RpiText>
    </Box>
  );
};
